import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import UserOrganizationCard from './UserOrganizationCard';

const UnassignedUsersPanel = ({ users = [], onNavigate }) => {
  if (!users.length) return null;

  return (
    <Card className="border-amber-200 bg-amber-50/40" data-testid="org-chart-unassigned-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-['Outfit'] text-amber-900">Organization Placement Pending</CardTitle>
        <p className="text-sm text-amber-800">
          {users.length} user{users.length === 1 ? '' : 's'} could not be placed using manager relationships and need organization data review.
        </p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-3">
          {users.map((user) => (
            <UserOrganizationCard key={user.id} node={user} compact onNavigate={onNavigate} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default UnassignedUsersPanel;
